<template>
    <div class="mask-bg">
         <div class="login-box">
          <div class="title">请您先登录<span @click="close"><a-icon type="close" style="font-size: medium;" /></span></div>
          <div>
                 <div class="form-box">
                  <div class="input-box">
                    <a-icon type="user" class="icon-before" style="font-size: large;" />
                    <input type="text" placeholder="用戶名">
                  </div>
                  <div class="submit-box" @click="submitFun">
                    登录
                  </div>
                 </div>
          </div>
         </div>
    </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customAlert: {
      type: Function
    }
  },
  data() {
    return {
    };
  },
  computed: {
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
  },
  mounted() {

  },
  methods: {
    close() {
      this.$emit('close','showLoginModal')
    },
    async submitFun() {
      let username = document.getElementsByTagName('input')[0].value
      if (!username) return this.$emit('customAlert', '用户名不能为空')
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post('/XYLPUser/getDetail', { username: username }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            sessionStorage.setItem('info',JSON.stringify(r.data.data))
            this.close()
          } else this.$emit('customAlert', msg || '用户不存在')
        }
      })
      this.$store.dispatch('SET_LOADING', false)
    }
  },

  watch: {
  }
};
</script>

<style scoped>
.mask-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.60);
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 311px;
  padding-bottom: 20px;
  margin: 0 auto;
  border-radius: 8px;
  background: #DF363A url('./../assets/img/bigWheel/bg_tc_zp.png') no-repeat center top / 100% auto;
}


.title {
  position: relative;
  padding: 20px 0 24px;
  color: #FFF;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

.title span {
  position: absolute;
  right: 10px;
}

.form-box {
  width: 287px;
  margin: 0 auto;
}

.input-box {
  height: 44px;
  line-height: 44px;
  border-radius: 32px;
  background: #FFFAF5;
}

.icon-before {
  padding-left: 16px;
  padding-right: 12px;
}

input {
  height: 40px;
  line-height: 40px;
  border: none;
}

input:focus,
input:focus-visible,
input,
input:active {
  border: none;
  outline: none;
}

.submit-box {
  margin-top: 32px;
  height: 44px;
  line-height: 44px;
  border-radius: 32px;
  color: #D40708;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(185deg, #FEE9A6 4.34%, #FED66A 96.13%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
}
</style>